import axios from 'axios'
import userActions from './user'
import modalActions from './modals'
import endpoint from '../utils/endpoint'
import { isAfter, endOfDay, parseISO } from 'date-fns'

export const loginSuccess = data => {
    return {
        type: 'LOGIN_SUCCESS',
    }
}

export const loginFailed = data => {
    return {
        type: 'LOGIN_FAILED',
    }
}

export const loginExpired = data => {
    return {
        type: 'LOGIN_EXPIRED',
    }
}

export const loggingIn = data => {
    return {
        type: 'LOGGING_IN',
        data: data,
    }
}

const saveLoginDetails = details => {
    axios
        .post(`${endpoint.getServiceEndpoint(process.env.NODE_ENV)}/usage`, {
            orgId: details.data.OrgId,
            userId: details.data.userId,
            eventType: 'login',
        })
        .catch(err => {
            console.error('Error trying to track login', err)
        })
}

const storeCSLoginCookie = trackDate => {
    return {
        type: 'CS_TRACK',
        data: trackDate,
    }
}

export const login = loginDeets => {
    return (dispatch, getState) => {
        dispatch(loggingIn(true))
        let url =
            process.env.NODE_ENV === 'production'
                ? 'https://app.beapplied.com/authenticate'
                : 'https://staging.beapplied.com/authenticate'
        const state = getState()
        const lastDailyLogin = state && state.auth.lastDailyLogin
        if (!lastDailyLogin || isAfter(new Date(), parseISO(lastDailyLogin))) {
            url = `${url}?trackTatLogin=true`
        }
        return axios
            .post(url, {
                email: loginDeets.email,
                password: loginDeets.password,
            })
            .then(response => {
                if (window.Appcues) {
                    window.Appcues.identify(response.data.userId)
                }
                dispatch(loginSuccess())
                dispatch(modalActions.closeLoginModal())
                dispatch(
                    userActions.storeUser(response.data),
                )
                dispatch(storeCSLoginCookie(endOfDay(new Date())))
                saveLoginDetails(response)
            })
            .catch(error => {
                if (
                    error.response &&
                    error.response.data.error === 'LoginExpired'
                ) {
                    dispatch(loginExpired(error))
                } else {
                    dispatch(loginFailed(error))
                }
            })
    }
}

export const logout = data => {
    return dispatch => {
        dispatch(userActions.removeUser())
    }
}

export default {
    login,
    logout,
    loggingIn,
    loginSuccess,
    loginFailed,
    loginExpired,
}
